import React from 'react';
import { Typography } from '@mui/material';
import OverviewShell from './OverviewShell';

const NoInsightsOverview: React.FC = () => (
    <OverviewShell>
        <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
            No insights generated for these questions yet. They will appear once calls have been analyzed.
        </Typography>
    </OverviewShell>
);

export default NoInsightsOverview;
